/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZahlungsartInputs */

const de__field_zahlungsart = /** @type {(inputs: _Field_ZahlungsartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsart`)
};

/**

* @param {_Field_ZahlungsartInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_zahlungsart = /** @type {((inputs?: _Field_ZahlungsartInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZahlungsartInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zahlungsart(inputs)
});